<template>
    <div class="policy-consent-checkbox">
        <ui-checkbox-with-text v-model="localAccepted">
            <span class="policy-consent-checkbox__text" :class="{'_small': small}">
                Нажимая «Отправить», вы соглашаетесь с условиями пользовательского соглашения.
                Мы обрабатываем ваши персональные данные на основании пункта&nbsp;5&nbsp;части&nbsp;1
                статьи&nbsp;6&nbsp;152&#8209;Ф3 «О персональных данных».
                Больше информации в <a :href="urls.policies.privacyPolicy"
                                       target="_blank">Политике конфиденциальности</a>.
            </span>
        </ui-checkbox-with-text>
        <div
            class="policy-consent-checkbox__error"
            v-if="showError"
            v-text="errorMessage"
        />
    </div>
</template>

<script>
import config from '~/config';

export default {
    name: 'auth-policy-consent-checkbox',
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
        showError: {
            type: Boolean,
        },
        errorMessage: {
            type: String,
            default: 'Необходимо ваше согласие',
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        urls: config.urls,
    }),
    model: {
        prop: 'checked',
        event: 'change',
    },
    methods: {

    },
    computed: {
        localAccepted: {
            get() {
                return this.checked;
            },
            set(newValue) {
                this.$emit('change', newValue);
            },
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.policy-consent-checkbox {
    &__text {
        .typography-body();

        &._small {
            .typography-caption();
        }
    }

    &__error {
        .typography-body();

        margin-top: 16px;

        color: @color-accent-negative;
        text-align: center;
    }

}
</style>
